import React from 'react';
import { Link } from 'react-router-dom';

import { getGenreList } from '../../actions/genre';
import GroupedList from '../../components/GroupedList';

import c from './Genre.less';

function GenreList(props) {
  return (
    <GroupedList
      componentName="GenreList"
      title="Mp3Caprice - Music Genres"
      description="A big choice of music genres to all tastes. Discover, buy and download high quality tunes for reasonable prices."
      header="Music genres"
      loadData={getGenreList}
      mapData={(store) => store.genres}
      itemRender={(item) => (<Link className={c.genreLink} to={`/genre/${item.slug}`}>{item.name}</Link>)}
      pathPrefix="genre"
      {...props}
    />
  );
}

export default GenreList;
